import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ReasonInputDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'app-reason-input-dialog',
  templateUrl: './reason-input-dialog.component.html',
  styleUrls: ['./reason-input-dialog.component.scss']
})
export class ReasonInputDialogComponent {
  reasonForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ReasonInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReasonInputDialogData,
    private fb: FormBuilder
  ) {
    // Set defaults
    this.data.confirmText = this.data.confirmText || 'Submit';
    this.data.cancelText = this.data.cancelText || 'Cancel';

    // Initialize form
    this.reasonForm = this.fb.group({
      reason: ['', [Validators.required]]
    });
  }

  onConfirm(): void {
    if (this.reasonForm.valid) {
      this.dialogRef.close(this.reasonForm.value.reason);
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}

